import styles from "./createprivategroup.module.scss";
import { Input, Modal, Select, Form } from 'antd';
import { Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import { initialStateModel, workContact } from "../../../../models/model";
import { useSelector } from "react-redux";
import { SearchFilter } from "../../../../base/utils";
import { SocketChatService } from "../../../../base/socketChatService";
import { userInfo } from "../../../../base/socketChatService/utils";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import store from "../../../../context/store/store";


type creategroupProps = {

  showGroupmodel: (status:boolean) => void;
  isModel: boolean;
  groupLogUsers:any;
  fromCallLog:boolean
}

type creategroupState = {
  groupName:string,
  description:string,
  descriptionError:boolean,
  groupNameError:boolean,
  addmember:Array<any>,
  contactList:Array<any>,
  searchContactList:Array<any>
  addmemberError:boolean; 
  groupType: number;
}
export default function CreatePrivateGroup({showGroupmodel, isModel,groupLogUsers,fromCallLog}:creategroupProps) {
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const workContacts: any = allReducer.contactReducer.workContacts;

  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  let { userdetails } = allReducer.loginReducer;
  let {host_address, company_id} =userdetails;
  const [isModalVisible1, setIsModalVisible] = useState(isModel)
 
 
  const [teamDetails, setDetails] = useState<creategroupState>({groupName:fromCallLog ? (groupLogUsers?.groupName):"",
    description:"", addmember:fromCallLog ? (groupLogUsers?.users):[], descriptionError:false, groupNameError:false,
    contactList:workContacts, searchContactList:workContacts, addmemberError:false,groupType:0});
  /*  const showModal1 = () => {setIsModalVisible1(true);};
   const handleOk1 = () => {setIsModalVisible1(false);};
   const handleCancel1 = () => {setIsModalVisible1(false);}; */

  const closeModel = ()=>{

    showGroupmodel(false);
    setIsModalVisible(false);

  };
  useEffect(() => {
    if(isModel){
      setIsModalVisible(true)
    }
  },[isModel]);

  const submitValues = ()=>{

    let {groupName, description, addmember,groupType} = teamDetails;
    if(!groupName && addmember.length === 0){
      setDetails({...teamDetails, groupNameError:true,addmemberError:true});
      return;
    }
    if(!groupName){
      setDetails({...teamDetails, groupNameError:true});
      return;
    }

    else if(addmember.length === 0){
      setDetails({...teamDetails, addmemberError:true});
      return;
    }

    else if (groupType !== 0) {
      toastInformation("Public Mode is Future Implementation", "failure");
      return;
    }
    let createTeamDetails:any = {};

    createTeamDetails.companyId = company_id;
    createTeamDetails.teamId= 0
    createTeamDetails.teamName = groupName;
    createTeamDetails.teamType = 1;
    createTeamDetails.description = description;
    createTeamDetails.createdBy = userdetails.sip_login_id;
    createTeamDetails.exceptGuest = 0;
    createTeamDetails.postMsg = 1;
    createTeamDetails.mention = 0;
    createTeamDetails.integration = 0;
    createTeamDetails.pinPost = 0;
    createTeamDetails.members = addmember.join();
    createTeamDetails.photoInfo = "";
    createTeamDetails.teamGuid = ""
    createTeamDetails.processType = 1;
    createTeamDetails.teamIdPrefix = "con";
    createTeamDetails.host = host_address;


    
    socketChat.createGroupChat(createTeamDetails);

    if(allReducer.contactReducer?.teamValidation === false){
    //showGroupmodel(false);
    setIsModalVisible(false);
    }
    
    //toastInformation("Team created successfully", "success");

  };


  const updateGroupname = (e:any)=>{
  
    let  details:any = {...teamDetails};

    if(e.target.name === "groupName"){

      if(e.target.value.length > 80){

        return true;

      }
    }

    details[e.target.name] = e.target.value;
    details[`${e.target.name}Error`] = false;
    setDetails(details);

  };


  const onChangeaddMembers = (value: any) => {

    setDetails({...teamDetails, addmember:value, searchContactList:teamDetails.contactList, addmemberError:false});
  };

  const onSearchMembers = (value:any)=>{
    let response =  SearchFilter(teamDetails?.contactList, value.toLowerCase());
    setDetails({...teamDetails, searchContactList:response});
  };

  const teamTypeOnchange = (e: any) => {
    
    setDetails({...teamDetails, groupType:e.target.value});
  };

 
  useEffect(() => {
    if(fromCallLog){
      setDetails({...teamDetails, addmember:groupLogUsers.users,groupName:groupLogUsers.groupName});
    }

  }, [groupLogUsers])
  let len = Math.ceil((teamDetails?.searchContactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  return (
    <>
      <div className={styles.createnewgroupscreen}>
        <Modal title="Create Team"
          centered
          visible={isModalVisible1}
          onOk={submitValues}
          onCancel={closeModel}
          cancelText="Cancel"
          okText="Create"
          maskClosable={false}
          width="493px"
          cancelButtonProps={{ className: 'urButton buttonWhite' }}
          okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup dateicon" >
          <div className={styles.half}>
            <div className={styles.inputfield}>
              <label>Team Name</label>
              {/* <div className={styles.groupName}> */}
               {teamDetails.groupType === 0 && <span className={`icon_Lockoutline ${styles.LockIconlft}`}></span>}
              <Input placeholder="Enter team name" name="groupName" className=
                { teamDetails?.groupNameError ? `hoverbdrBlueInput ${styles.inputerror}` : "hoverbdrBlueInput"}
              onChange={(e)=>updateGroupname(e)} value={teamDetails?.groupName}></Input>
              <span className={styles.inputright}>{80 - teamDetails?.groupName?.length}</span>
              
              {/* </div> */}
            </div>
            {teamDetails?.groupNameError && <span className="errorin">Give your team a name</span>}
            <div className={styles.inputfield}>
              <label>Description (Optional)</label>              
                <Input placeholder="Purpose of this team" name="description"
                className={`hoverbdrBlueInput ${styles.inputarea}`} onChange={(e)=>updateGroupname(e)}></Input>           
             
            </div>
            <div className={styles.inputfield}>
              <div className={styles.selectopt}>
                <div className={styles.formGrouprow}>
                  <label>Add Member</label>
          
                  <div className={styles.shareSelect}>
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                       value={teamDetails.addmember}
                      placeholder="Search for extension to member"
                      dropdownClassName="newChatSel"
                      className={`createNewSel ${teamDetails.addmemberError ? styles.inputerror : "" }`}
                      onChange={(e:any)=>onChangeaddMembers(e)}  onSearch={onSearchMembers} showSearch={true} 
                     /*  optionLabelProp = "label" */ filterOption={false}>
                      {teamDetails?.searchContactList.map((contact:workContact, index:number)=>{
                        return (
                          <option value={contact.sip_login_id} key={index}>
                            <div className="dropdowndesign">
                              {/* <div className="usergroups"><span>{contact?.caller_id.charAt(0)}<b></b></span></div> */}
                              <div className="usergroupss">
                                <URAvatarGroup className={`lefts size20 colorBG${random_color[index]} ${(contact?.ImageURL !== null && contact?.ImageURL !== "")?'avatarWithImg':'' }`} profileInfo={<>
                                  {contact.ImageURL ?
                                    <img src={contact.ImageURL} alt="" /> :
                                    <span>{contact?.first_name?.charAt(0).toUpperCase()+contact?.last_name?.charAt(0).toUpperCase()}</span>}
                                  <URStatusDot
                                    className={userStatusColor(contact?.user_status,'small')}/>
                                </> } />
                              </div>
                              <div className="names">{contact?.caller_id}</div>
                              <div className="ext">{contact?.ext}</div>
                            </div>
                          </option>
                        ); 

                      })}
                    </Select>
                  </div>
                  {teamDetails.addmemberError && <p className={styles.error}>Add people to this team</p>}
                </div>
              </div>
            </div>
            <div className={styles.radiobuttonsec}>
              <Form.Item>
                <Radio.Group onChange={teamTypeOnchange} defaultValue={0}>
                  <Radio value={1} >Public
                    <span className={styles.radiosmalltxt}>Visible to any co - worker</span></Radio>
                  <Radio value={0}>Private <span className={styles.radiosmalltxt}>(Invite only)</span></Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};
